module.exports = __webpack_public_path__ + "img/ruby3.ad11072b.png";